import { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { IconButton } from '@mui/material';
import { ExpandLess as ExpandLessIcon } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
  toTop: {
    zIndex: 2,
    position: 'fixed',
    bottom: '2vh',
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.another,
    '&:hover, &.Mui-focusVisible': {
      transition: '0.3s',
      color: theme.palette.primary.another,
      backgroundColor: '#DCDCDC',
    },
    [theme.breakpoints.up('xs')]: {
      right: '6.5%',
      backgroundColor: theme.palette.secondary.main,
    },
    [theme.breakpoints.up('lg')]: {
      right: '6%',
    },
  },
}));

const ScrollToTop = ({ showBelow }) => {
  const [show, setShow] = useState(showBelow ? false : true);

  const classes = useStyles();

  useEffect(() => {
    if (showBelow) {
      window.addEventListener(`scroll`, handleScroll);
      return () => window.removeEventListener(`scroll`, handleScroll);
    }
  });

  const handleScroll = () => {
    if (window.pageYOffset > showBelow) {
      if (!show) setShow(true);
    } else {
      if (show) setShow(false);
    }
  };

  const handleClick = () => {
    window[`scrollTo`]({ top: 0, behavior: 'smooth' });
  };

  return (
    <div>
      {show && (
        <IconButton
          size="medium"
          onClick={handleClick}
          className={classes.toTop}
        >
          <ExpandLessIcon />
        </IconButton>
      )}
    </div>
  );
};

export default ScrollToTop;
